import { Adapter } from "@/core/models/adapter";
import { cloneDeep } from "@/core/utils/utils";

export const TYPE_INSTRUCTION_CIRCUIT_PATH = "/media/cirx/circuits/";

export const TYPE_AGENDA = "agenda";
export const TYPE_CLOSE = "close";
export const TYPE_DELIVER = "deliver";
export const TYPE_INSERT = "insert";
export const TYPE_JOIN = "join";
export const TYPE_MAILBOX = "mailbox";
export const TYPE_NONE = "none";
export const TYPE_POST = "post";
export const TYPE_PRINT = "print";
export const TYPE_PROTECT = "protect";
export const TYPE_SIGN = "sign";

export const INSTRUCTION_TYPE_LIST = [
  TYPE_AGENDA,
  TYPE_CLOSE,
  TYPE_DELIVER,
  TYPE_INSERT,
  TYPE_JOIN,
  TYPE_MAILBOX,
  TYPE_POST,
  TYPE_PRINT,
  TYPE_PROTECT,
  TYPE_SIGN,
  TYPE_NONE, // Laisser cette icône en dernier
];

/**
 * @param {string} type
 * @return {string}
 */
export const getAssociatedSvgTypeInstruction = (type) => {
  return TYPE_INSTRUCTION_CIRCUIT_PATH + type + ".svg";
};

export class CircuitInstruction {
  constructor() {
    this.id = null;
    this.sequence = null;
    this.label = null;
    this.type = null;
    this.circuit = null;
    this.circuitId = null;
    this.dispatchCircuitRule = null;
    this.dispatchCircuitRuleId = null;
  }

  /**
   * @return {string}
   */
  getJsonLdId() {
    return `/circuit-instructions/${this.id}`;
  }

  /**
   * @return {string}
   */
  getDispatchCircuitRuleJsonLdId() {
    return `/dispatch-circuit-rules/${this.dispatchCircuitRuleId}`;
  }

  /**
   * @return {string}
   */
  getCircuitJsonLdId() {
    return `/circuits/${this.circuitId}`;
  }

  getAssociatedSvgTypeInstruction() {
    return getAssociatedSvgTypeInstruction(this.type);
  }
}

export class CircuitInstructionAdapter extends Adapter {
  static adapt(dispatchCircuitInstructionApi) {
    const circuitInstruction = new CircuitInstruction();
    circuitInstruction.id = dispatchCircuitInstructionApi?.id;
    circuitInstruction.sequence = dispatchCircuitInstructionApi?.sequence;
    circuitInstruction.label = dispatchCircuitInstructionApi?.label;
    circuitInstruction.type = dispatchCircuitInstructionApi?.type;
    return circuitInstruction;
  }

  static adaptForRequest(circuitInstruction) {
    const requestCircuitInstruction = cloneDeep(circuitInstruction);
    if (circuitInstruction.circuitId !== null) {
      requestCircuitInstruction.circuit = circuitInstruction.getCircuitJsonLdId();
    } else {
      delete requestCircuitInstruction.circuit;
    }
    if (circuitInstruction.dispatchCircuitRuleId !== null) {
      requestCircuitInstruction.dispatchCircuitRule = circuitInstruction.getDispatchCircuitRuleJsonLdId();
    } else {
      delete requestCircuitInstruction.dispatchCircuitRule;
    }
    return requestCircuitInstruction;
  }
}
